module.exports = __webpack_public_path__ + "img/6.924fd391.png";